import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const phoneNumber = "+961 81 092 891";
const address = "Lebanon";

// TODO: fix links and icon
let socialList = [
  {
    iconName: "icofont-whatsapp",
    siteLink: "https://wa.me/96181092891",
  },
  {
    iconName: "icofont-instagram",
    siteLink: "https://instagram.com",
  },
  {
    iconName: "icofont-facebook",
    siteLink: "https://facebook.com",
  },
  {
    iconName: "icofont-tiktok",
    siteLink: "https://tiktok.com",
  },
];

const Header = () => {
  const [menuToggle, setMenuToggle] = useState(false);
  const [socialToggle, setSocialToggle] = useState(false);
  const [headerFiexd, setHeaderFiexd] = useState(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      setHeaderFiexd(true);
    } else {
      setHeaderFiexd(false);
    }
  });

  return (
    <header
      className={`header-section ${headerFiexd ? "header-fixed fadeInUp" : ""}`}
      style={headerFiexd ? { position: 'fixed', top: 0, left: 0, right: 0, width: '100%', zIndex: 999, background: '#fff', boxShadow: '0 0 10px rgba(0,0,0,0.1)' } : {}}
    >
      {/* <div className={`header-top ${socialToggle ? "open" : ""}`}>
        <div className="container">
          <div className="header-top-area">
            <ul className="lab-ul left">
              <li>
                <i className="icofont-ui-call"></i> <span>{phoneNumber}</span>
              </li>
              <li>
                <i className="icofont-location-pin"></i> {address}
              </li>
            </ul>
            <ul
              className="lab-ul social-icons d-flex align-items-center"
              style={{}}
            >
              <li>
                <p>Find us on : </p>
              </li>
              {socialList.map((val, i) => (
                <li
                  key={i}
                  style={{ transition: "all 0.3s ease", cursor: "pointer" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.querySelector("i").style.color =
                      "var(--theme-primary-color-hover)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.querySelector("i").style.color =
                      "var(--theme-primary-color)")
                  }
                >
                  <a
                    href={val.siteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className={val.iconName}
                      style={{ color: "var(--theme-primary-color)" }}
                    ></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div> */}
      <div className="header-bottom">
        <div className="container">
          <div className="header-wrapper">
            <div style={{
              display: 'flex',
              alignItems: 'center',
              maxWidth: '200px',
              flex: '0 0 auto'
            }}>
              <Link to="/" style={{
                display: 'block',
                width: '100%'
              }}>
                <img 
                  src="assets/images/logo/mindcraftlb_logo.png" 
                  alt="MindcraftLB"
                  style={{
                    maxWidth: '100%',
                    height: 'auto'
                  }}
                />
              </Link>
            </div>
            <div className="menu-area">
              <div className="menu">
                <ul 
                  className={`lab-ul ${menuToggle ? "active" : ""}`}
                  style={menuToggle ? { backgroundColor: "var(--theme-primary-color)" } : {}}
                >
                  <li>
                    <NavLink 
                      to="/"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--theme-primary-color-hover)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--theme-primary-color-hover)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li className="">
                    <a
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-bs-offset="0,0"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--theme-primary-color-hover)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                    >
                      Courses
                    </a>
                    <ul className="lab-ul dropdown-menu">
                      <li>
                        <NavLink
                          to="/course"
                          style={{ transition: "all 0.3s ease" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "var(--theme-primary-color)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          Course
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/course-single"
                          style={{ transition: "all 0.3s ease" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "var(--theme-primary-color)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          Course Details
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/course-view"
                          style={{ transition: "all 0.3s ease" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "var(--theme-primary-color)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          Course View
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink 
                      to="/contact"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--theme-primary-color-hover)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                    >
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </div>

              {/* <Link to="/login" className="login"><i className="icofont-user"></i> <span>LOG IN</span> </Link>
                            <Link to="/signup" className="signup"><i className="icofont-users"></i> <span>SIGN UP</span> </Link> */}

              <div
                className={`header-bar d-lg-none ${menuToggle ? "active" : ""}`}
                onClick={() => setMenuToggle(!menuToggle)}
                style={{ marginRight: "15px" }}
              >
                <span style={{ backgroundColor: "var(--theme-primary-color)" }}></span>
                <span style={{ backgroundColor: "var(--theme-primary-color)" }}></span>
                <span style={{ backgroundColor: "var(--theme-primary-color)" }}></span>
              </div>
              {/* <div
                className="ellepsis-bar d-lg-none"
                onClick={() => setSocialToggle(!socialToggle)}
              >
                <i className="icofont-info-square"></i>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
